<template>
  <div class="sh-h5-radio">
    <div class="sh-radio-cell" v-for="(item, index) in options" :key="index">
      <label class="sh-radiolist-lable">
        <span class="sh-radio-select">
          <input
            :disabled="isCheckStatus"
            type="radio"
            class="sh-radio-input"
            name="shH5Radio"
            :value="item.value || item"
            v-model="currentValue">
          <span class="sh-radio-core"></span>
        </span>
        <span class="sh-radio-lable" :class="isCheckStatus?'isCheckStatus':''">{{item.label || item}}</span>
      </label>
      <span
        v-if="!item.hiddenBtn && !isCheckStatus"
        class="sh-radio-btn"
        @click.self="checkClick(index)">如何查看 ？
      </span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ShRadio',
  data () {
    return {
      currentValue: ''
    }
  },
  props: {
    options: {
      type: Array,
      required: true,
      default: () => []
    },
    // 是否是查看状态
    isCheckStatus: {
      type: Boolean,
      required: false,
      default: () => {
        return false
      }
    },
    choseRadio: {
      type: Number,
      required: false,
      default: () => {
        return 0
      }
    }
  },
  methods: {
    checkClick (index) {
      this.$emit('checkClick', index)
    }
  },
  watch: {
    currentValue () {
      if (this.isCheckStatus) return
      this.$emit('change', this.currentValue)
    },
    choseRadio: {
      handler(newVal) {
        this.currentValue = newVal
      },
      immediate: true
    }
  }
}
</script>

<style scoped lang="scss">
  .sh-h5-radio{
    box-sizing: border-box;
    overflow: hidden;
    line-height: 1;
  }
  .sh-radio-cell{
    display: flex;
    align-items: center;
    height: 56px;
    min-width: 92%;
    margin: 0 10px;
    line-height: 1;
    box-sizing: border-box;
    font-size: 15px;
    overflow: hidden;
    border-bottom: 1px solid #eee;
  }
  .sh-radio-cell:last-child{
    border-bottom: none;
  }
  .sh-radiolist-lable{
    display: flex;
    align-items: center;
    flex-grow: 1;
    box-sizing: border-box;
    overflow: hidden;    
  }
  .sh-radio-select{
    display: flex;
    align-items: center;
  }
  .sh-radio-select .sh-radio-input{
    display: none;
  }
  .sh-radio-select .sh-radio-core{
    display: inline-block;
    background-color: #fff;
    border-radius: 100%;
    border: 1px solid #ccc;
    position: relative;
    width: 20px;
    height: 20px;
    vertical-align: middle;
  }
  .sh-radio-lable{
    margin-left: 10px;
    flex-grow: 1;
    &.isCheckStatus {
      color: #cbbccb;
    }
  }
  .sh-radio-core:after {
    content: " ";
    border: 2px solid #fff;
    border-left: 0;
    border-top: 0;
    top: 3px;
    left: 6px;
    position: absolute;
    width: 4px;
    height: 8px;
    transform: rotate(45deg) scale(0);
    transition: transform .2s;
  }
  .sh-radio-input:checked+.sh-radio-core:after{
    transform: rotate(45deg) scale(1);
  }
  .sh-radio-input:checked+.sh-radio-core{
    background-color: #02BC01;
    border-color: #02BC01;
  }
  .sh-radio-btn{
    color: #409eff;
  }
  @media screen and (max-width: 320px){
    .sh-radio-cell{
      font-size: 13px;
    }
  }
</style>
